<template>
  <button
    class="tooth-popup"
    type="button"
    v-bind:class="{ flip, selected }"
    v-on:click="toggle">
    <svg
      class="tooth-popup__parts"
      width="26"
      height="51"
      viewBox="0 0 26 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M9.33491 25.7554C8.65292 27.4314 8.19336 33.1048 8.04883 35.7319L19.3628 36.6797C19.2751 32.3066 18.9756 21.8745 18.4797 15.1303C17.9837 8.3862 15.0181 4.13952 13.5973 2.85919C13.3648 2.59315 12.7293 2.32046 12.0473 3.35802C11.1949 4.65498 10.8074 9.69313 10.7299 13.135C10.6524 16.5769 10.1874 23.6603 9.33491 25.7554Z" />
      <path d="M19.2542 49.1493L8.48197 49.1992C7.96562 49.1327 7.43257 49.0614 7.00695 48.7615C6.92166 48.7015 6.83381 48.6315 6.74664 48.5504C6.00929 47.8641 5.98587 46.7459 6.02951 45.7396C6.11874 43.6814 6.43116 40.5122 7.24198 37.6264C7.44307 36.9107 7.72069 36.2817 8.04837 35.7309C9.23225 33.7407 11.0696 32.7706 12.3116 32.4187C12.6977 32.3092 13.1008 32.289 13.5021 32.289C14.2844 32.289 15.0728 32.3836 15.7753 32.7277C16.8543 33.2562 18.1995 34.1858 18.8667 35.5313C19.0354 35.8716 19.2016 36.2608 19.3624 36.6787C19.3996 36.7752 19.4358 36.8734 19.4712 36.9731C20.6837 40.3847 21.1837 44.089 20.9591 47.7027C20.9275 48.2111 20.747 48.5598 20.5365 48.7883C20.2223 49.1293 19.7178 49.1493 19.2542 49.1493Z" />
    </svg>
    <div class="tooth-popup__number">{{number}}</div>
  </button>
</template>

<script>
import popupTeethMixin from '@/mixins/popupTeethMixin';

export default {
  mixins: [popupTeethMixin],
  name: 'ToothUp1',
};
</script>

<style>
</style>
